export const calculatePaymentDate = ({
  issueDate,
  paymentConditionType,
  paymentConditionDays,
  paymentConditionDate,
}) => {
  if (!issueDate) return null;

  const base = new Date(`${issueDate}T00:00:00`);
  if (Number.isNaN(base.getTime())) return null;

  if (paymentConditionType === 'cash') {
    return base;
  }

  if (paymentConditionType === 'days') {
    const days = parseInt(paymentConditionDays, 10) || 0;
    const paymentDate = new Date(base);
    paymentDate.setDate(paymentDate.getDate() + days);
    return paymentDate;
  }

  if (paymentConditionType === 'date' && paymentConditionDate) {
    const paymentDate = new Date(`${paymentConditionDate}T00:00:00`);
    return Number.isNaN(paymentDate.getTime()) ? null : paymentDate;
  }

  return null;
};

export const calculateDaysUntilPayment = (params) => {
  const paymentDate = calculatePaymentDate(params);
  if (!paymentDate || !params.issueDate) return null;

  const issueDate = new Date(`${params.issueDate}T00:00:00`);
  if (Number.isNaN(issueDate.getTime())) return null;

  const diffTime = paymentDate - issueDate;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
